export default "__VITE_ASSET__2cfa34a5__"